"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9339],{

/***/ 29339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31555);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68312);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93264);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30653);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62642);
/* harmony import */ var gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7749);
/* harmony import */ var gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);











if (true) {
  gsap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].registerPlugin */ .ZP.registerPlugin(gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_5__.DrawSVGPlugin);
}

var MyComponent = function MyComponent(_ref) {
  var _data$posts, _data$section_data, _data$section_data2, _data$section_data3, _data$section_data4;

  var data = _ref.data,
      id = _ref.id,
      offset = _ref.offset;
  var products = data === null || data === void 0 ? void 0 : (_data$posts = data.posts) === null || _data$posts === void 0 ? void 0 : _data$posts.list;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var shapes = ".rotate_svg line , .rotate_svg react, .rotate_svg path",
        tl = gsap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].timeline */ .ZP.timeline({
      repeat: -1,
      yoyo: true
    });
    tl.fromTo(shapes, {
      drawSVG: "0"
    }, {
      duration: 0.5,
      drawSVG: "100%",
      stagger: 0.1
    }, "-=0.5").to(shapes, {
      duration: 0.5,
      drawSVG: "100%"
    });
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledComponent, {
    id: id,
    offset: offset,
    className: 'products  pb-200',
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          md: 4,
          children: data !== null && data !== void 0 && (_data$section_data = data.section_data) !== null && _data$section_data !== void 0 && _data$section_data.subtitle ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_1__["default"], {
            margin: '',
            text: data === null || data === void 0 ? void 0 : (_data$section_data2 = data.section_data) === null || _data$section_data2 === void 0 ? void 0 : _data$section_data2.subtitle,
            fontSize: '44',
            fontWeight: '400',
            lineHeight: '56'
          }) : ''
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
          md: {
            span: 7,
            offset: 1
          },
          children: data !== null && data !== void 0 && (_data$section_data3 = data.section_data) !== null && _data$section_data3 !== void 0 && _data$section_data3.short_desc ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("p", {
            className: 'split-up short',
            children: [data === null || data === void 0 ? void 0 : (_data$section_data4 = data.section_data) === null || _data$section_data4 === void 0 ? void 0 : _data$section_data4.short_desc, " "]
          }) : ''
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
      className: "content-wrp",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
          children: products && (products === null || products === void 0 ? void 0 : products.length) > 0 && (products === null || products === void 0 ? void 0 : products.map(function (e, index) {
            var _e$data, _e$data2, _e$data3, _e$data4;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
              "data-lag": "".concat(index == 0 ? '0.05' : index == 1 ? '0.1' : index == 2 ? '0.13' : ''),
              className: 'custom-loop',
              md: 4,
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                className: "single-item",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
                  className: "content",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
                    className: "rotate rotate_svg",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "422.894",
                      height: "563.04",
                      viewBox: "0 0 422.894 563.04",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("g", {
                        id: "Group_20853",
                        "data-name": "Group 20853",
                        transform: "translate(-19.553 129.54)",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("g", {
                          id: "Group_20852",
                          "data-name": "Group 20852",
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                            id: "Custom_vector_2",
                            transform: "translate(15099 2689.667)",
                            opacity: "0.2",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3969",
                              "data-name": "Line 3969",
                              y1: "281",
                              x2: "141",
                              transform: "translate(-14798 -2537.667)",
                              stroke: "#fff",
                              strokeWidth: "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3970",
                              "data-name": "Line 3970",
                              x1: "281.333",
                              transform: "translate(-14938.333 -2537.374)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3971",
                              "data-name": "Line 3971",
                              y1: "562",
                              x2: "281",
                              transform: "translate(-14938 -2818.667)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3972",
                              "data-name": "Line 3972",
                              x1: "140",
                              y1: "281",
                              transform: "translate(-14938 -2818.667)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3973",
                              "data-name": "Line 3973",
                              x1: "141",
                              y1: "281",
                              transform: "translate(-15079 -2818.667)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3974",
                              "data-name": "Line 3974",
                              y1: "281",
                              x2: "141",
                              transform: "translate(-14938 -2818.667)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3975",
                              "data-name": "Line 3975",
                              x1: "140.667",
                              transform: "translate(-14797.667 -2818.707)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_3976",
                              "data-name": "Line 3976",
                              x1: "140.667",
                              transform: "translate(-15079 -2818.707)",
                              stroke: "#fff",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_4007",
                              "data-name": "Line 4007",
                              x1: "140",
                              transform: "translate(-14938 -2256.667)",
                              fill: "none",
                              stroke: "#fff",
                              "stroke-width": "1"
                            })]
                          })
                        })
                      })
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
                    children: index + 1
                  }), (e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.description) && (0,react_html_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.description), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
                    className: "flex",
                    children: [(e === null || e === void 0 ? void 0 : (_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h3", {
                      children: e === null || e === void 0 ? void 0 : (_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.title
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("svg", {
                      id: '',
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "44",
                      height: "44",
                      viewBox: "0 0 44 44",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                        id: "Circle",
                        transform: "translate(16429 -2014)",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                          id: "Rectangle_492",
                          "data-name": "Rectangle 492",
                          transform: "translate(-16429 2014)",
                          fill: "none",
                          stroke: "#c6c6c6",
                          "stroke-width": "1",
                          opacity: "0.5",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("rect", {
                            width: "44",
                            height: "44",
                            rx: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("rect", {
                            x: "0.5",
                            y: "0.5",
                            width: "43",
                            height: "43",
                            rx: "21.5",
                            fill: "none"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                          id: "Group_4824",
                          "data-name": "Group 4824",
                          transform: "translate(-17065.5 434.5)",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                            id: "Group_4823",
                            "data-name": "Group 4823",
                            transform: "translate(11 4)",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_9",
                              "data-name": "Line 9",
                              x2: "5",
                              y2: "5",
                              transform: "translate(647.5 1592.5)",
                              fill: "none",
                              stroke: "#fff",
                              strokeLinecap: "round",
                              "stroke-width": "1"
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                              id: "Line_10",
                              "data-name": "Line 10",
                              x1: "5",
                              y2: "5",
                              transform: "translate(647.5 1597.5)",
                              fill: "none",
                              stroke: "#fff",
                              strokeLinecap: "round",
                              "stroke-width": "1"
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("line", {
                            id: "Line_11",
                            "data-name": "Line 11",
                            x2: "10",
                            transform: "translate(653.5 1601.5)",
                            fill: "none",
                            stroke: "#fff",
                            strokeLinecap: "round",
                            "stroke-width": "1"
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("g", {
                          id: "Rectangle_5661",
                          "data-name": "Rectangle 5661",
                          transform: "translate(-16429 2058) rotate(-90)",
                          fill: "none",
                          stroke: "#fff",
                          "stroke-width": "1",
                          opacity: "0",
                          strokeDasharray: "0 140",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("rect", {
                            width: "44",
                            height: "44",
                            rx: "22",
                            stroke: "none"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("rect", {
                            x: "0.5",
                            y: "0.5",
                            width: "43",
                            height: "43",
                            rx: "21.5",
                            fill: "none"
                          })]
                        })]
                      })
                    })]
                  })]
                })
              })
            });
          }))
        })
      })
    })]
  });
};

var StyledComponent = styled_components__WEBPACK_IMPORTED_MODULE_9__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "Products__StyledComponent",
  componentId: "sc-13d1cxx-0"
})(["position:relative;background:#f2f2f2;padding-top:305px;.short{font-size:24px;line-height:32px;font-weight:500;}.content-wrp{margin-top:40px;.single-item{background:#3c3c3b;position:relative;padding-top:100%;overflow:hidden;margin-bottom:40px;.content{position:absolute;left:0;right:0;bottom:0;top:0;z-index:1;padding:40px;display:flex;flex-direction:column;justify-content:space-between;span{font-size:136px;line-height:136px;color:#C6C6C6;display:block;margin-bottom:80px;font-family:'Avenir Book';transition:1s all cubic-bezier(.25,.74,.22,.99);position:relative;z-index:2;}p{font-size:20px;font-weight:300;line-height:28px;color:#FFFFFF;z-index:2;position:absolute;top:40px;margin:auto;width:calc(100% - 80px);transition:1s all cubic-bezier(.25,.74,.22,.99);transform:translateY(-200%);}.flex{position:relative;z-index:2;bottom:35px;align-items:flex-end;display:flex;justify-content:space-between;min-height:105px;h3{font-size:40px;line-height:52px;color:#FFFFFF;letter-spacing:-1px;display:block;font-family:'Avenir Heavy';}svg{position:absolute;bottom:15px;right:0;display:none;#Rectangle_5661{transition:1s all cubic-bezier(.25,.74,.22,.99);}}}.rotate_svg{position:absolute;left:0;right:0;bottom:0;top:0;object-fit:cover;z-index:2;svg{height:calc(100% + 100px);width:calc(100% + 100px);}}img{position:absolute;left:0;right:0;bottom:0;top:0;object-fit:cover;z-index:2;}&:before{content:'';transition:1s all cubic-bezier(.25,.74,.22,.99);position:absolute;left:0;right:0;bottom:0;z-index:1;width:100%;height:0;background:", ";}&:hover{span{transform:translateY(-50px);opacity:0;}p{transform:unset;}.flex{svg{#Rectangle_5661{stroke-dasharray:140px;opacity:1;}}}&:before{height:100%;}}}}}@media (max-width:992px) and (min-width:768px){.col-md-4,.col-md-7{flex:0 0 100%;max-width:100%;margin:0;h2{margin-bottom:40px;}}.content-wrp .single-item .content span{font-size:100px;line-height:100px;}.content-wrp .single-item .content .flex svg{bottom:13px;}}@media (max-width:767px){padding-top:120px !important;padding-bottom:90px !important;}@media(min-width:1024px) and (max-width:1440px){.content-wrp .single-item .content .flex h3{margin-right:30px;}}"], _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_10__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(MyComponent));

/***/ })

}]);